import { Injectable } from "@angular/core";
import { AddressPayload, CheckRegisterRequest, CheckRegisterResponse, ConfirmRegisterUserPayload, ConfirmRegisterUserResponse, MyAddressAllResponse, MyVehicleAllForChange, RegisterUserPayload, RegisterUserResponse, UpdateNamePayload, VehicleLogPayload } from "../../../models/user.model";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { ConfigService } from "../../config.service";
import { ApiMethodService } from "../../../../tools/services/api/method-api/apiMethod.service";
import { Observable } from "rxjs";
import { environment } from '../../../../../environments/environment';
import { RegisterMemberNewPayload, RegisterMemberResponse } from "../../../models/member.model";
import { StatusAPIResponse, StatusAPIResponseMain, TaxpayerInfo } from "../../../models/information.model";
import { ObjectFeeResponse } from "../../../models/parking.model";
import { RequestFullTaxPayload } from "../../../models/payment.model";
import { ActivateVehicleInfo, CardByVehicleTypeInfo, ConfirmActivateMemberPayload } from "../../../models/activate.model";

@Injectable({
    providedIn: 'root',
})

export class ApiMemberService {
    private tokenUrl = `${environment.apiPrivateUrl}`;

    constructor(
        private http: HttpClient,
        private configService: ConfigService,
        private apiMethods: ApiMethodService,
    ) { }

    getMyAddress(token: string, uid: string): Observable<MyAddressAllResponse[]> {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });
        const url = this.tokenUrl + `/Cityparking/GetMyAddressAll?uid=${uid}`;
        return this.http.get<MyAddressAllResponse[]>(url, { headers });
    }

    checkFullTax(token: string, uid: string): Observable<StatusAPIResponse> {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });
        const url = this.tokenUrl + `/Cityparking/CheckFullTax?uid=${uid}`;
        return this.http.get<StatusAPIResponse>(url, { headers });
    }

    getFeeDetails(site_id: number): Observable<ObjectFeeResponse> {
        return this.http.get<ObjectFeeResponse>(
            this.tokenUrl + `/Cityparking/GetFeeDetails?site_id=${site_id}`,
        );
    }

    getAddressByTaxId(data: string): Observable<TaxpayerInfo> {
        const url =
            this.tokenUrl + `/backoffice/Search_address_by_key?data=${data}`;
        return this.http.get<TaxpayerInfo>(url, {});
    }

    UpdateAddress(
        body: AddressPayload,
        token: string,
    ): Observable<StatusAPIResponse> {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });
        return this.http.post<StatusAPIResponse>(
            this.tokenUrl + '/Cityparking/ManageAddress',
            body,
            { headers },
        );
    }

    RequestTaxFull(
        body: RequestFullTaxPayload,
        token: string,
    ): Observable<StatusAPIResponseMain> {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });
        return this.http.post<StatusAPIResponseMain>(
            this.tokenUrl + '/Cityparking/RequestTaxFull',
            body,
            { headers },
        );
    }

    RequestChangeMemberData(
        body: VehicleLogPayload,
        token: string,
    ): Observable<StatusAPIResponse> {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });
        return this.http.post<StatusAPIResponse>(
            this.tokenUrl + '/Cityparking/RequestChangeMemberData',
            body,
            { headers },
        );
    }

  getRegisterMemberPayment(
    uid: string,
    token: string,
  ): Observable<RegisterMemberResponse[]> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    const url = this.tokenUrl + '/Cityparking/getRegisterMemberPayment';
    const params = new HttpParams().set('Uid', uid);
    return this.http.get<RegisterMemberResponse[]>(url, {
      headers,
      params,
    });
  }

  


}